module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/mres3-63f3bfe5b17414343da204fbe4b52e11.jpg";